module.exports = __webpack_public_path__ + "img/landinglogo.d3c30f3c.png";